import React from "react";
import "style/HomePage.scss";

import { Col, Row, Container, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";

import ModalDropdown from "../components/ModalDropdown";

import en from "../config/i18n/english/english";
import de from "../config/i18n/german/german";

import Rakete from "assets/video/Rakete.mp4";
import RaketeS from "assets/video/RaketeS.mp4";
import SliderBox from "components/SliderBox";

import Plan from "components/Plan";

import { default as SvgHeaderTitle } from "assets/SvgHeaderTitle.svg";
import { default as SvgMachineLearning } from "assets/SvgMachineLearning.svg";

import { default as SvgHeaderNavigation } from "assets/SvgHeaderNavigation.svg";
import { default as SvgHeaderNavigationClose } from "assets/SvgHeaderNavigationClose.svg";
import { default as SvgInformation } from "assets/SvgInformation.svg";

import { default as SvgChangeLanguage } from "assets/icon_lang.svg";

import { default as SvgHeaderRight } from "assets/SvgHeaderRight.svg";
import { default as SvgHeaderLeft } from "assets/SvgHeaderLeft.svg";
import { default as SvgHeaderMiddle } from "assets/SvgHeaderMiddle.svg";

interface Props {}

interface State {
  dropdown: boolean;
  dropdownLanguage: boolean;

  manual: any;
  windowWidth: number;
  language: any;
}

class HomePage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      dropdown: false,
      dropdownLanguage: false,
      manual: en.Plans,
      windowWidth: 0,
      language: en,
    };
    this.handleResizeEvent = this.handleResizeEvent.bind(this);
    this.handleScrollPositionEvent = this.handleScrollPositionEvent.bind(this);
  }

  componentDidMount() {
    if (sessionStorage.getItem("lang") === null) {
      const browserLanguage = navigator.language.split("-")[0];
      this.setState({
        language: browserLanguage === "de" ? de : en,
        manual: browserLanguage === "de" ? de.Plans : en.Plans,
      });
    } else {
      const sessionLang = sessionStorage.getItem("lang");
      this.setState({
        language: sessionLang === "de" ? de : en,
        manual: sessionLang === "de" ? de.Plans : en.Plans,
      });
    }

    this.handleResizeEvent();

    window.addEventListener("scroll", (e) => this.handleScrollPositionEvent());
    window.addEventListener("resize", this.handleResizeEvent);
    return () => {
      window.removeEventListener("resize", this.handleResizeEvent);
      window.removeEventListener("scroll", (e) =>
        this.handleScrollPositionEvent()
      );
    };
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  handleResizeEvent() {
    this.setState({ windowWidth: window.innerWidth });
  }

  handleScrollPositionEvent() {
    this.setState({ dropdown: false });
    this.setState({ dropdownLanguage: false });
  }

  render() {
    const { language } = this.state;

    return (
      <>
        <ModalDropdown
          showDropdown={this.state.dropdown}
          showDropdownLanguage={this.state.dropdownLanguage}
          homepage={this.state.dropdown}
        />

        <div className="homepage">
          <div className="header">
            <video id="video" autoPlay loop muted>
              <source src={Rakete} type="video/mp4" />
              Ihr Browser unterstützt kein HTML5 video
            </video>

            <video id="video-s" autoPlay loop muted>
              <source src={RaketeS} type="video/mp4" />
              Ihr Browser unterstützt kein HTML5 video
            </video>

            <Container
              fluid={true}
              className="p-0 container-title-dropdown container-logo-dropdown"
            >
              <Row className="g-0" style={{ height: "68px" }}>
                <Col className="svg-header-title">
                  <Link to="/">
                    <img
                      alt="Title"
                      className="svgHeaderTitle"
                      src={SvgHeaderTitle}
                    />
                  </Link>
                </Col>

                <Col className="dropdown text-end">
                  <Button
                    onClick={() => {
                      this.setState({
                        dropdown: false,
                        dropdownLanguage: !this.state.dropdownLanguage,
                      });
                    }}
                  >
                    {this.state.dropdownLanguage ? (
                      <img
                        src={SvgHeaderNavigationClose}
                        className="svg-dropdown svg-change-language"
                        alt="Dropdown"
                      />
                    ) : (
                      <img
                        src={SvgChangeLanguage}
                        className="svg-dropdown svg-change-language"
                        alt="Dropdown"
                      />
                    )}
                  </Button>

                  <Button
                    onClick={() => {
                      this.setState({
                        dropdownLanguage: false,
                        dropdown: !this.state.dropdown,
                      });
                    }}
                  >
                    {this.state.dropdown ? (
                      <img
                        src={SvgHeaderNavigationClose}
                        className="svg-dropdown"
                        alt="Dropdown"
                      />
                    ) : (
                      <img
                        src={SvgHeaderNavigation}
                        className="svg-dropdown"
                        alt="Dropdown"
                      />
                    )}
                  </Button>
                </Col>
              </Row>
            </Container>

            <div className="header-svg-container" style={{ width: "100%" }}>
              <table width="100%">
                <tbody>
                  <tr className="tablerow">
                    <td>
                      <img
                        alt="Main concept of Marksim"
                        src={SvgHeaderLeft}
                        style={{ marginLeft: "5%", position: "relative" }}
                        className="svgHeaderLeft"
                      />
                    </td>
                    <td>
                      <p style={{ textAlign: "center" }}>
                        <img
                          alt="Main concept of Marksim"
                          src={SvgHeaderMiddle}
                          className="svgHeaderMiddle"
                        />
                      </p>
                    </td>
                    <td align="right">
                      <img
                        alt="Main concept of Marksim"
                        src={SvgHeaderRight}
                        style={{ marginRight: "5%", position: "relative" }}
                        className="svgHeaderRight"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="body">
            <div className="body-header-description">
              <div className="body-header-text">
                <div>
                  <h1 className="body-header-text-h1">
                    {language.homepage.headerTitle1st}
                    <br />
                    <span className="body-header-text-content">
                      {language.homepage.headerTitle2st}
                    </span>
                  </h1>
                </div>
                <span className="body-header-text-description">
                  <span>{language.homepage.headerDescriptionFirst[0]}</span>{" "}
                  {language.homepage.headerDescriptionFirst[1]}{" "}
                  <span>{language.homepage.headerDescriptionFirst[2]}</span>{" "}
                  {language.homepage.headerDescriptionFirst[3]}
                  <br />
                  <br />
                  {language.homepage.headerDescriptionSecond[0]}{" "}
                  <Link className="link-contact" to="/contact">
                    {language.homepage.headerDescriptionSecond[1]}
                  </Link>
                </span>
              </div>

              <div className="body-header-img">
                <img
                  src={SvgMachineLearning}
                  className="body-header-svg"
                  alt="Machine Learning"
                />
              </div>
            </div>

            <div className="how-does-it-work">
              <div className="how-does-it-work-content">
                <h1>
                  <span> {language.homepage.bodyHeader[0]}</span>{" "}
                  {language.homepage.bodyHeader[1]}
                </h1>
                <div className="slider">
                  <SliderBox items={language.homepage.bodyHeaderContent} />
                </div>
              </div>
            </div>

            <div className="plan">
              <div className="plan-header">
                <div className="plan-header-content">
                  <p>
                    {language.homepage.bodyFooterContent[0]}{" "}
                    <span>{language.homepage.bodyFooterContent[1]}</span>{" "}
                    {language.homepage.bodyFooterContent[2]}
                    <br />
                    {language.homepage.bodyFooterContent[3]}{" "}
                    <span>{language.homepage.bodyFooterContent[4]}</span>
                  </p>
                  <img
                    src={SvgHeaderTitle}
                    className="plan-header-title"
                    alt="Title"
                  />
                </div>
              </div>

              <div className="plan-body-main">
                <div className="plan-body">
                  <h2>
                    {language.homepage.bodyFooterChoosePlan[0]}{" "}
                    <span>{language.homepage.bodyFooterChoosePlan[1]}</span>
                  </h2>

                  {this.state.windowWidth > 600 ? (
                    <>
                      <div className="plan-description">
                        <div className="plan-description-space"></div>
                        {this.state.manual["plan_description"] &&
                          this.state.manual["plan_description"].map(
                            (plan: any) => {
                              return (
                                <span key={plan.id}>
                                  <hr />
                                  <table className="plan-description-table">
                                    <tbody>
                                      <tr>
                                        <td>
                                          <>
                                            <span>{plan.description} </span>
                                            {plan.info !== "undefined" ? (
                                              <Tooltip
                                                title={plan.info}
                                                placement="right-start"
                                              >
                                                <img
                                                  className="plan-description-table-icon"
                                                  src={SvgInformation}
                                                  alt="Information"
                                                />
                                              </Tooltip>
                                            ) : null}
                                          </>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </span>
                              );
                            }
                          )}
                      </div>
                    </>
                  ) : null}

                  <Plan
                    items={this.state.manual["plan"]}
                    planDescription={this.state.manual["plan_description"]}
                    planInfoText={this.state.manual["plan_information_text"]}
                    windowWidth={this.state.windowWidth}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default HomePage;
